import { MediaTypes } from "../../constants";
import { MediaNameInput } from "./MediaNameInput";
import { Media } from "../../types/media";
import { FullLine } from "../../styles/styles";
import styled from "styled-components";
import { FixaFormField } from "@coworker/apprestructured/src/shared/wrappers/FixaFormField/FixaFormField";
import {
  checkEmptyMediaName,
  checkMediaName,
  validationMessage,
} from "../../Organisms/Settings/SettingsForm.helper";
import { useTranslation } from "@coworker/locales";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { getMediaTypeText } from "../../tools";

const LimitWidth = styled("div")`
  width: calc(100% - 42px);
  margin: auto;
`;

const Container = styled("div")`
  width: calc(100%);
`;

interface RadioButtonWithInputProps {
  media: Media;
  medias: Media[];
  mediaType: MediaTypes;
  currentCheckedMediaType: MediaTypes;
  onSave: (newMedia: Media) => void;
  onChange?: () => void;
}

export const RadioButtonWithInput = ({
  media,
  medias,
  mediaType,
  onSave,
  currentCheckedMediaType,
  onChange,
}: RadioButtonWithInputProps) => {
  const { t } = useTranslation();

  return (
    <Container>
      <FixaListView
        id={`select-media-${mediaType}-${media.id ?? ""}`}
        showDivider={false}
        size="small"
      >
        <FullLine margin="0" />
        <FixaListViewItem
          showDivider={true}
          control="radiobutton"
          title={getMediaTypeText(mediaType)}
          size="small"
          inset={true}
          controlProps={{
            subtle: true,
            checked: currentCheckedMediaType === mediaType,
            value: mediaType,
          }}
          onChange={() => onChange?.()}
        />

        {currentCheckedMediaType === mediaType && (
          <>
            <>
              {currentCheckedMediaType === MediaTypes.ROOM && (
                <LimitWidth>
                  <p>{media.name}</p>
                </LimitWidth>
              )}
            </>
            <>
              {currentCheckedMediaType !== MediaTypes.ROOM && (
                <LimitWidth>
                  <FixaFormField
                    shouldValidate={
                      !medias ||
                      checkEmptyMediaName(media) ||
                      checkMediaName(media, medias)
                    }
                    validation={{
                      msg: validationMessage(media, medias ?? [], t),
                    }}
                  >
                    <MediaNameInput
                      mediaType={mediaType}
                      media={media}
                      onSave={(newMedia) => onSave(newMedia)}
                      withAsterisk={false}
                    />
                  </FixaFormField>
                </LimitWidth>
              )}
            </>
          </>
        )}
      </FixaListView>
    </Container>
  );
};
